import { connect } from 'react-redux';
import Modal from 'comp/modals/new_group';
import { cache } from 'utils';

const mapToProps = state => ({
  status: state.fetch.group_create || cache.empty_obj
});

export default connect(mapToProps)(Modal);



// WEBPACK FOOTER //
// ./src/containers/modals/NewGroup.js